/*  ========================================================================
    # Scripts - Header
    ========================================================================  */

/**
 * Script that handles the header navigation hamburger menu toggle.
 */
const Header = {
  cfg: {
    headerWrapper: document.querySelector('.c-header__wrapper'),
    hamburger: document.querySelector('.c-header__hamburger'),
    nav: document.querySelector('.c-header__nav'),
    navItems: document.querySelectorAll('.c-header__nav-item'),
    navItemWithSubnav: document.querySelectorAll('.c-header__nav-item.has-subnav'),
  },

  /**
   * Initialize the header script.
   */
  init() {
    if (!this.cfg.hamburger || !this.cfg.nav) return;

    this.cfg.hamburger.addEventListener('click', () => this.toggleNav());
    this.cfg.navItems.forEach(item => {
      item.addEventListener('click', () => this.closeNav());
    });

    // Close nav when clicking outside
    document.addEventListener('click', (e) => {
      if (
        this.cfg.nav.classList.contains('is-active') &&
        !this.cfg.nav.contains(e.target) &&
        !this.cfg.hamburger.contains(e.target) &&
        !this.cfg.headerWrapper.contains(e.target)
      ) {
        this.closeNav();
      }
    });

    // Close nav on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.cfg.nav.classList.contains('is-active')) {
        this.closeNav();
      }
    });

    // Subnav toggle
    this.cfg.navItemWithSubnav.forEach(item => {
      const toggle = item.querySelector('.c-header__subnav-toggle');
      if (toggle) {
        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleSubnav(item);
        });
      }
    });
  },

  /**
   * Toggle the navigation menu.
   */
  toggleNav() {
    this.cfg.headerWrapper.classList.toggle('is-active');
    this.cfg.nav.classList.toggle('is-active');
    this.cfg.hamburger.classList.toggle('is-active');
    this.cfg.hamburger.setAttribute(
      'aria-expanded',
      this.cfg.nav.classList.contains('is-active')
    );
  },

  /**
   * Toggle the subnavigation menu.
   */
  toggleSubnav(item) {
    const subnav = item.querySelector('.c-header__subnav-list');
    const toggle = item.querySelector('.c-header__subnav-toggle');

    if (subnav && toggle) {
      subnav.classList.toggle('is-active');
      toggle.setAttribute(
        'aria-expanded',
        subnav.classList.contains('is-active')
      );
    }
  },

  /**
   * Close the navigation menu.
   */
  closeNav() {
    this.cfg.headerWrapper.classList.remove('is-active');
    this.cfg.nav.classList.remove('is-active');
    this.cfg.hamburger.classList.remove('is-active');
    this.cfg.hamburger.setAttribute('aria-expanded', 'false');
  },
};

export default Header;
